const LinkNotification = `{{LINK.FORMS}}`;

export { LinkNotification };
